import {useAuthStore} from "@/stores/auth";
import PermissionDeniedError from "@/errors/PermissionDeniedError";

let authStore;
const getAuthStore = () => {
    if (!authStore) authStore = useAuthStore();
    return authStore;
}

export const HasPermission = (permission) => {
    return getAuthStore().hasPermission(permission);
}

export const HasPermissionOrThrow = (permission) => {
    if (!HasPermission(permission)) {
        throw new PermissionDeniedError(permission)
    }
    return true;
}